import { render } from "./NotificationPage.vue?vue&type=template&id=5c4b609a&ts=true"
import script from "./NotificationPage.vue?vue&type=script&lang=ts"
export * from "./NotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__